import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ed1a8846")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Vigencia de la oferta", -1)
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Fecha de publicación *", -1)
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  key: 0,
  class: "form-error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Por favor, completa este campo")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "form-error"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una fecha mayor al dia de hoy.")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "form-error"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una fecha menor a 1 año.")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "form-error"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una fecha menor a la de finalización.")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Fecha de finalización *", -1)
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Por favor, completa este campo")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "form-error"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una fecha menor a 1 año.")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 2,
  class: "form-error"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una fecha mayor al dia de hoy.")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 3,
  class: "form-error"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una fecha mayor a la de publicación.")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "buttons" }
const _hoisted_40 = { class: "step-button" }
const _hoisted_41 = { class: "step-button" }
const _hoisted_42 = { class: "step-button" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("fieldset", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_Calendar, {
            id: "publishDate",
            modelValue: _ctx.state.publishDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.publishDate = $event)),
            class: "box-size",
            autocomplete: "off",
            placeholder: "DD/MM/AAA",
            baseZIndex: "9999"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.publishDate.$errors[0]?.$validator == 'required')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.v$.publishDate.$errors[0]?.$validator == 'minDateValidator')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.v$.publishDate.$errors[0]?.$validator == 'maxDateValidator')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.v$.publishDate.$errors[0]?.$validator == 'datesValidator')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_21,
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_Calendar, {
            id: "endDate",
            modelValue: _ctx.state.endDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.endDate = $event)),
            class: "box-size",
            autocomplete: "off",
            placeholder: "DD/MM/AAA",
            baseZIndex: "9999"
          }, null, 8, ["modelValue"])
        ]),
        (_ctx.v$.endDate.$errors[0]?.$validator == 'required')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
          : _createCommentVNode("", true),
        (_ctx.v$.endDate.$errors[0]?.$validator == 'maxDateValidator')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
          : _createCommentVNode("", true),
        (_ctx.v$.endDate.$errors[0]?.$validator == 'minDateValidator')
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
          : _createCommentVNode("", true),
        (_ctx.v$.endDate.$errors[0]?.$validator == 'datesValidator')
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.back())),
          label: "Anterior",
          class: "back-saveChanges"
        })
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_component_Button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveChanges())),
          label: "Guardar cambios",
          class: "back-saveChanges"
        })
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_component_Button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.next())),
          label: "Publicar",
          class: "next"
        })
      ])
    ])
  ]))
}